import React from 'react'
import PropTypes from 'prop-types'
import './Container.css'

const Container = ({ children, fullWidthMobile }) => (
  <div className={`bs__grid__container${fullWidthMobile ? ' bs__grid__container--full-width-mobile' : ''}`}>{children}</div>
)

Container.defaultProps = {
  fullWidthMobile: false,
}

Container.propTypes = {
  children: PropTypes.node.isRequired,
  fullWidthMobile: PropTypes.bool,
}

export default Container
